"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _base = _interopRequireDefault(require("./base"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Reset = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Reset, _Component);

  var _super = _createSuper(Reset);

  function Reset() {
    (0, _classCallCheck2["default"])(this, Reset);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Reset, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_base["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M56 32.9v.001c0 12.739-9.788 23.192-22.255 24.248-1.127.095-2.083-.85-2.083-1.982v-5.256c0-.998.784-1.763 1.776-1.878 7.568-.882 13.46-7.332 13.46-15.132 0-8.402-6.834-15.235-15.234-15.235S16.43 24.499 16.429 32.9h7.313L13.463 49.865c-.773 1.278-2.63 1.269-3.393-.015L0 32.9h7.328c0-13.441 10.895-24.336 24.336-24.336S56 19.46 56 32.9z"
      }));
    }
  }]);
  return Reset;
}(_react.Component);

exports["default"] = Reset;
(0, _defineProperty2["default"])(Reset, "defaultProps", {
  height: '16px',
  predefinedClassName: 'data-ex-icons-reset'
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21tb24vaWNvbnMvcmVzZXQudHN4Il0sIm5hbWVzIjpbIlJlc2V0IiwicHJvcHMiLCJDb21wb25lbnQiLCJoZWlnaHQiLCJwcmVkZWZpbmVkQ2xhc3NOYW1lIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdBOztBQUNBOzs7Ozs7SUFFcUJBLEs7Ozs7Ozs7Ozs7OztXQU1uQixrQkFBUztBQUNQLDBCQUNFLGdDQUFDLGdCQUFELEVBQVUsS0FBS0MsS0FBZixlQUNFO0FBQU0sUUFBQSxDQUFDLEVBQUM7QUFBUixRQURGLENBREY7QUFLRDs7O0VBWmdDQyxnQjs7O2lDQUFkRixLLGtCQUNHO0FBQ3BCRyxFQUFBQSxNQUFNLEVBQUUsTUFEWTtBQUVwQkMsRUFBQUEsbUJBQW1CLEVBQUU7QUFGRCxDIiwic291cmNlc0NvbnRlbnQiOlsiLy8gU1BEWC1MaWNlbnNlLUlkZW50aWZpZXI6IE1JVFxuLy8gQ29weXJpZ2h0IGNvbnRyaWJ1dG9ycyB0byB0aGUga2VwbGVyLmdsIHByb2plY3RcblxuaW1wb3J0IFJlYWN0LCB7Q29tcG9uZW50fSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgQmFzZSwge0Jhc2VQcm9wc30gZnJvbSAnLi9iYXNlJztcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgUmVzZXQgZXh0ZW5kcyBDb21wb25lbnQ8UGFydGlhbDxCYXNlUHJvcHM+PiB7XG4gIHN0YXRpYyBkZWZhdWx0UHJvcHMgPSB7XG4gICAgaGVpZ2h0OiAnMTZweCcsXG4gICAgcHJlZGVmaW5lZENsYXNzTmFtZTogJ2RhdGEtZXgtaWNvbnMtcmVzZXQnXG4gIH07XG5cbiAgcmVuZGVyKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8QmFzZSB7Li4udGhpcy5wcm9wc30+XG4gICAgICAgIDxwYXRoIGQ9XCJNNTYgMzIuOXYuMDAxYzAgMTIuNzM5LTkuNzg4IDIzLjE5Mi0yMi4yNTUgMjQuMjQ4LTEuMTI3LjA5NS0yLjA4My0uODUtMi4wODMtMS45ODJ2LTUuMjU2YzAtLjk5OC43ODQtMS43NjMgMS43NzYtMS44NzggNy41NjgtLjg4MiAxMy40Ni03LjMzMiAxMy40Ni0xNS4xMzIgMC04LjQwMi02LjgzNC0xNS4yMzUtMTUuMjM0LTE1LjIzNVMxNi40MyAyNC40OTkgMTYuNDI5IDMyLjloNy4zMTNMMTMuNDYzIDQ5Ljg2NWMtLjc3MyAxLjI3OC0yLjYzIDEuMjY5LTMuMzkzLS4wMTVMMCAzMi45aDcuMzI4YzAtMTMuNDQxIDEwLjg5NS0yNC4zMzYgMjQuMzM2LTI0LjMzNlM1NiAxOS40NiA1NiAzMi45elwiIC8+XG4gICAgICA8L0Jhc2U+XG4gICAgKTtcbiAgfVxufVxuIl19